

<template>
  <div class="signup app-content">
    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row mx-2 pb-2">
          <div class="col-12">
            <router-link :to="'./mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./movie_list'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.how_to_use_movie")}}</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-12 py-2">
            <p class="article_title mb-12"><b>{{$t("message.how_to_use_movie")}}</b></p>
            <p class="article_title mb-12">{{$t("message.description_movie_trans")}}</p>
            <b-card >
              <div class="mt-3">
                <a href="https://youtu.be/qCtcUQ0JBBY" class="mgr-20" target="_blank"><b>{{$t("message.movie_news")}}</b></a><br>
                <youtube :video-id="'qCtcUQ0JBBY'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/SpKkgvpouis" class="mgr-20" target="_blank"><b>{{$t("message.movie_exam")}}</b></a><br>
                <youtube :video-id="'SpKkgvpouis'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/dmKdQg5I5z4" class="mgr-20" target="_blank"><b>{{$t("message.movie_predict_pass")}}</b></a><br>
                <youtube :video-id="'dmKdQg5I5z4'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/HCdvs0fd6b4" class="mgr-20" target="_blank"><b>{{$t("message.movie_ave_study_test")}}</b></a><br>
                <youtube :video-id="'HCdvs0fd6b4'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/1QnSGCh0ZKc" class="mgr-20" target="_blank"><b>{{$t("message.movie_similar_exam")}}</b></a><br>
                <youtube :video-id="'1QnSGCh0ZKc'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/mqBTtArClyE" class="mgr-20" target="_blank"><b>{{$t("message.movie_learning_text")}}</b></a><br>
                <youtube :video-id="'mqBTtArClyE'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/FgqOr9PwHH4" class="mgr-20" target="_blank"><b>{{$t("message.movie_solved_exam")}}</b></a><br>
                <youtube :video-id="'FgqOr9PwHH4'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/rh_ogFbXg44" class="mgr-20" target="_blank"><b>{{$t("message.movie_pased_exam")}}</b></a><br>
                <youtube :video-id="'rh_ogFbXg44'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/-v8IP0b8Q68" class="mgr-20" target="_blank"><b>{{$t("message.movie_resume_regist")}}</b></a><br>
                <youtube :video-id="'-v8IP0b8Q68'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/39RfF1Wl5Zw" class="mgr-20" target="_blank"><b>{{$t("message.movie_pass_document_regist")}}</b></a><br>
                <youtube :video-id="'39RfF1Wl5Zw'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/EbsqHSwyULo" class="mgr-20" target="_blank"><b>{{$t("message.movie_agency_service")}}</b></a><br>
                <youtube :video-id="'EbsqHSwyULo'" :fitParent="true"/>
              </div>
              <div class="mt-3">
                <a href="https://youtu.be/CeEXLySm9G8" class="mgr-20" target="_blank"><b>{{$t("message.movie_consule_service")}}</b></a><br>
                <youtube :video-id="'CeEXLySm9G8'" :fitParent="true"/>
              </div>

            </b-card>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  async mounted() {
    this.$store.commit('setLoading', false)
  }
}
</script>

<style scoped lang="scss">
a{
  color: #000000;
  text-decoration: underline;
}
</style>
